import React, { useEffect, useState } from "react";
import Scalar from "./Scalar";
import IScalarForm from "../interface/IScalarForm";
import { Slider } from "@blueprintjs/core";
 
const Speedometer = (props: IScalarForm): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<SpeedometerEnabled {...props} />}
        desabledForm={<SpeedometerDesabled {...props} />}
    /> 
}
export default Speedometer

const SpeedometerDesabled = ( props: IScalarForm ): JSX.Element => {
    return <div className='my-3 text-center '>{props.value }</div>
}
const SpeedometerEnabled = ( props: any ) => {
    const [value, setValue] = useState(props.value);
    const [demo, setDemo] = useState( Math.floor(props.value / (props.max || 100) * 100 ));
    useEffect(() => {
        setValue( props.value )
        setDemo( props.value / (props.max || 100) * 100 ) 
    }, [props.value])
    const handleChange = (v: number) => {
        setValue( v );
        setDemo( v / (props.max || 100) * 100 );
        if( props.onChange ) {
            props.onChange( v,  props.field, "" )
        } 
    };
    return <div>
        <div style={{ padding: "0px 12px" }}>
            <div className="position-relative" style={{ width: "300px" } }>
                <svg
                    width="300" 
                    height="180" 
                    viewBox="0 0 300 180" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="300" height="180" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M152.991 34.67C152.706 30.9785 147.294 30.9785 147.009 34.67L138.696 142.139C136.395 144.776 135 148.225 135 152C135 160.284 141.716 167 150 167C158.284 167 165 160.284 165 152C165 148.225 163.606 144.776 161.304 142.139L152.991 34.67Z"
                        fill="#424E82"
                        transform={`rotate(${-90 + 1.8 * demo}, 150, 152)`}
                    />
                    <g transform="translate(150, 152)">
                        <circle r="8" fill="#FFF"/>
                        {
                            Array(41)
                                .fill(0)
                                    .map( (_, i) => <Tick key={i} index={i} value={demo } /> )
                        }
                    </g>
                </svg>
            </div>
            <div className="position-relative" style={{ width: "324px", height: "24px" } }>
                <Slider
                    min={0}
                    max={props.max}
                    stepSize={1}
                    labelStepSize={Math.floor( props.max / 3 )}
                    value={value}
                    onChange={handleChange}
                />     
            </div>
        </div>  
    </div>  
}

interface IValue {
    index: number
    value: number
}
function Tick({ index, value }: IValue) {
    const { x1, y1, x2, y2, color } = deriveData(index, value);
    return /*#__PURE__*/(
        React.createElement("line", {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            stroke: color,
            strokeWidth: "3",
            strokeLinecap: "round"
        }));


}

function deriveData(index: number, value: number) {
    const r1 = 130;

    const r2 = 150;
    const r3 = 140;
    const delta = Math.PI / 40;
    const angle = delta * index - Math.PI;

    const ss = Math.sin(angle);
    const cc = Math.cos(angle);

    const rs = index % 5 === 0 ? r1 : r3;

    const x1 = rs * cc;
    const y1 = rs * ss;
    const x2 = r2 * cc;
    const y2 = r2 * ss;

    const color = Math.ceil(value * (41 / 100)) > index ? "#424E82" : "#E8EBF9";
    return { x1, y1, x2, y2, color };
}